/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import Vue from 'vue'
import { Random } from "random-js";
import axios from '@/axios.js'
import con from "@/firebase/firebaseInit.ts";
import Handlebars from 'handlebars';
import AddToCalendar from 'vue-add-to-calendar'
import firebase from 'firebase';
import ls from "@/common/localStorage"

Vue.use(AddToCalendar);
var cn = ls.getSessionEventCollectionName();
var Session_Client_Id = ls.getSessionValueByKey('Session_Client_Id');
var Session_Event_Id = ls.getSessionValueByKey('Session_Event_Id');
var uerActionRef = con.eventDB.collection(cn).doc("Analytics").collection("UserAction");
var userViewRef = con.eventDB.collection(cn).doc("Analytics").collection("UserView");
var userRef = con.instanceDB.doc("Analytics").collection("UserAction");
var userLoginRef = con.eventDB.collection(cn).doc("Analytics").collection("UserLogin");
var PageEngagementFetchAPI = con.PageEngagementFetchAPI;
var PageEngagementUserWiseFetchAPI = con.PageEngagementUserWiseFetchAPI;
var PageEngagementUserSpecificDataFetchAPI = con.PageEngagementUserSpecificDataFetchAPI;
var Session_TimeZone = ls.getSessionValueByKey('Session_Event_TZ');
var LoginSummaryFetchAPI = con.LoginSummaryFetchAPI;
var UserJourneyTopLevelFetchAPI = con.UserJourneyTopLevelFetchAPI;
var UserSpecificJourneyFetchAPI = con.UserSpecificJourneyFetchAPI;
var FetchLiveVisitorDataAPI = con.FetchLiveVisitorDataAPI;
var UniqueLoginSummaryFetchAPI = con.UniqueLoginSummaryFetchAPI;
var FetchAllUserActionByPageNameOrUserId = con.FetchAllUserActionByPageNameOrUserId;
export default {
    fetchPageViewData(context, filterDayOrhours) {
        var hours = 0;
        if (filterDayOrhours == 6 || filterDayOrhours == 12 || filterDayOrhours == 24) {
            hours = filterDayOrhours;
        } else if (filterDayOrhours == 3 || filterDayOrhours == 7) {
            hours = (filterDayOrhours * 24);
        } else {
            hours = (5000 * 24);
        }
        return new Promise((resolve, reject) => {
            var mObj = {};
            const markers = []
            let requestData = {
                "instanceId": "OA_UAT",
                "clientId": Session_Client_Id,
                "eventId": Session_Event_Id,
                "numHours": hours,
            }
            let headers = {
                "content-type": "application/json"
            }
            axios.post(PageEngagementFetchAPI, requestData, { headers: headers }).then((response) => {
                response.data.rows.map((row4) => {
                    mObj.page = row4.pageName;
                    mObj.TotalViews = row4.viewCount;
                    mObj.TotalActions = row4.actionCount;
                    mObj.Total = row4.viewCount + row4.actionCount
                    markers.push(mObj);
                    mObj = {};
                });
                resolve({ status: 200, data: markers })
            }).catch((error) => {
                console.log('Error fetching page engagement data==:', error)
            })

        })

    },
    fetchPageViewUserViewData(context, pageName) {
        //debugger
        return new Promise((resolve, reject) => {
            let markers = []
            let markers1 = []
            uerActionRef.where("page", "==", pageName).where("actionType", "==", "view").get().then(querySnapshot => {
                //querySnapshot.docs.forEach(doc => {
                //    markers.push(doc.data())
                //})
                querySnapshot.docs.forEach(doc => {
                    var data = doc.data();
                    var indx = 0;
                    var docs = markers1.filter(function (value) {
                        if (value.UID == data.UID) {
                            markers1[indx].Total++;
                        }
                        indx++;
                        return value.UID == data.UID;
                    });
                    if (docs.length == 0) {
                        var mObj = {};
                        mObj.page = data.page;
                        mObj.Type = 'view';
                        mObj.UID = data.UID;
                        mObj.Uname = data.Uname;
                        mObj.UserEmail = data.UserEmail;
                        mObj.Total = 1;
                        markers1.push(mObj)
                    }
                });
                markers1.sort(
                    function (a, b) {
                        if (a.Total > b.Total) {
                            return -1;
                        }
                        if (a.Total < b.Total) {
                            return 1;
                        }
                        return 0;
                    });
                resolve({ status: 200, data: markers1 })
                //resolve(markers1);
            }).catch(function (error) {
                //console.log('Error getting attendee:', error)
                reject(error)
            })
        })
    },
    fetchPageViewUserActionData(context, pageName) {
        //debugger
        return new Promise((resolve, reject) => {
            let markers = []
            let markers1 = []
            uerActionRef.where("page", "==", pageName).where("actionType", "==", "action").get().then(querySnapshot => {
                //querySnapshot.docs.forEach(doc => {
                //    markers.push(doc.data())
                //})
                querySnapshot.docs.forEach(doc => {
                    var data = doc.data();
                    var indx = 0;
                    var docs = markers1.filter(function (value) {
                        if (value.UID == data.UID) {
                            markers1[indx].Total++;
                        }
                        indx++;
                        return value.UID == data.UID;
                    });
                    if (docs.length == 0) {
                        var mObj = {};
                        mObj.page = data.page;
                        mObj.Type = 'action';
                        mObj.UID = data.UID;
                        mObj.Uname = data.Uname;
                        mObj.UserEmail = data.UserEmail;
                        mObj.Total = 1;
                        markers1.push(mObj)
                    }
                });
                markers1.sort(
                    function (a, b) {
                        if (a.Total > b.Total) {
                            return -1;
                        }
                        if (a.Total < b.Total) {
                            return 1;
                        }
                        return 0;
                    });
                resolve({ status: 200, data: markers1 })
                //resolve(markers1);
            }).catch(function (error) {
                //console.log('Error getting attendee:', error)
                reject(error)
            })
        })
    },
    fetchPageViewUserData(context, feild) {
        var hours = 0;
        var filterDayOrhours = feild['filterDayOrhours'];
        var pageName = feild['page'];
        if (filterDayOrhours == 6 || filterDayOrhours == 12 || filterDayOrhours == 24) {
            hours = filterDayOrhours;
        } else if (filterDayOrhours == 3 || filterDayOrhours == 7) {
            hours = (filterDayOrhours * 24);
        } else {
            hours = (5000 * 24);
        }
        return new Promise((resolve, reject) => {
            var mObj = {};
            const markers = []
            let requestData = {
                "instanceId": "OA_UAT",
                "clientId": Session_Client_Id,
                "eventId": Session_Event_Id,
                "pageName": pageName,
                "numHours": hours,
            }
            let headers = {
                "content-type": "application/json"
            }
            axios.post(PageEngagementUserWiseFetchAPI, requestData, { headers: headers }).then((response) => {
                response.data.rows.map((row4) => {
                    mObj.page = pageName;
                    mObj.UID = row4.userId;
                    mObj.Uname = row4.userName;
                    mObj.UserEmail = row4.userEmail;
                    mObj.TotalViews = row4.viewCount;
                    mObj.TotalActions = row4.actionCount;
                    mObj.Total = row4.viewCount + row4.actionCount;
                    markers.push(mObj);
                    mObj = {};
                });
                resolve({ status: 200, data: markers })
            }).catch((error) => {
                console.log('Error fetching user page engagement data==:', error)
            })

        })
    },
    fetchPageViewUserDetailsData(context, fParams) {
        debugger
        var pageName = fParams.page;
        var uid = fParams.uid;
        var filterDayOrhours = fParams.filtrDay;
        var hours = 0;
        if (filterDayOrhours == 6 || filterDayOrhours == 12 || filterDayOrhours == 24) {
            hours = filterDayOrhours;
        } else if (filterDayOrhours == 3 || filterDayOrhours == 7) {
            hours = (filterDayOrhours * 24);
        } else {
            hours = (5000 * 24);
        }
        return new Promise((resolve, reject) => {
            var mObj = {};
            const markers = []
            let requestData = {
                "instanceId": "OA_UAT",
                "clientId": Session_Client_Id,
                "eventId": Session_Event_Id,
                "pageName": pageName,
                "userId": uid,
                "numHours": hours,
                "timeZone": Session_TimeZone
            }
            let headers = {
                "content-type": "application/json"
            }
            axios.post(PageEngagementUserSpecificDataFetchAPI, requestData, { headers: headers }).then((response) => {
                response.data.rows.map((row4) => {
                    mObj.ActionLabel = row4.actionName;
                    mObj.Action = row4.actionType;
		            mObj.UserAgent = row4.os;
                    mObj.ActionTimeStr = row4.dtm;
                    markers.push(mObj);
                    mObj = {};
                });
                resolve({ status: 200, data: markers })
            }).catch((error) => {
                console.log('Error fetching page engagement data==:', error)
            })
        })
    },
    fetchUserJourneyData(context, filterDayOrhours) {
        var hours = 0;
        if (filterDayOrhours == 6 || filterDayOrhours == 12 || filterDayOrhours == 24) {
            hours = filterDayOrhours;
        } else if (filterDayOrhours == 3 || filterDayOrhours == 7) {
            hours = (filterDayOrhours * 24);
        } else {
            hours = (5000 * 24);
        }
        return new Promise((resolve, reject) => {
            var mObj = {};
            const markers = []
            let requestData = {
                "instanceId": "OA_UAT",
                "clientId": Session_Client_Id,
                "eventId": Session_Event_Id,
                "numHours": hours,
            }
            let headers = {
                "content-type": "application/json"
            }
            axios.post(UserJourneyTopLevelFetchAPI, requestData, { headers: headers }).then((response) => {
                response.data.rows.map((row4) => {
                    mObj.page = 'user_joirney';
                    mObj.UID = row4.userId;
                    mObj.Uname = row4.userName;
                    mObj.Total = row4.viewCount + row4.actionCount;
                    mObj.TotalViews = row4.viewCount;
                    mObj.TotalActions = row4.actionCount;
                    markers.push(mObj);
                    mObj = {};
                });
                resolve({ status: 200, data: markers })
            }).catch((error) => {
                console.log('Error fetching user Journey data==:', error)
            })
        })
    },
    fetchUserJourneyDetailsData(context, field) {
        var filterDayOrhours = field.filterdays;
        var hours = 0;
        if (filterDayOrhours == 6 || filterDayOrhours == 12 || filterDayOrhours == 24) {
            hours = filterDayOrhours;
        } else if (filterDayOrhours == 3 || filterDayOrhours == 7) {
            hours = (filterDayOrhours * 24);
        } else {
            hours = (5000 * 24);
        }
        return new Promise((resolve, reject) => {
            var mObj = {};
            const markers = []
            let requestData = {
                "instanceId": "OA_UAT",
                "clientId": Session_Client_Id,
                "eventId": Session_Event_Id,
                "userId": field.uid,
                "numHours": hours,
                "timeZone": Session_TimeZone
            }
            let headers = {
                "content-type": "application/json"
            }
            axios.post(UserSpecificJourneyFetchAPI, requestData, { headers: headers }).then((response) => {
                response.data.rows.map((row4) => {
                    mObj.page = row4.pageName;
                    mObj.ActionLabel = row4.actionName;
                    mObj.Action = row4.actionType;
                    mObj.DeviceInfo = row4.os;
                    mObj.ActionTimeStr = row4.dtm;
                    markers.push(mObj);
                    mObj = {};
                });
                resolve({ status: 200, data: markers })
            }).catch((error) => {
                console.log('Error fetching user Journey details data==:', error)
            })
        })
    },
    fetchUserLoginData(context, filterdays) {
        //debugger
        var hours = 0;
        if (filterdays == 3 || filterdays == 7 || filterdays == 15 || filterdays == 30) {
            hours = (filterdays * 24);
        } else if (filterdays == 0) {
            hours = 24;
        } else if ([6,12,48].includes(filterdays)) {
            hours = filterdays;
        } else {
            hours = (5000 * 24);
        }
        return new Promise((resolve, reject) => {
            var mObj = {};
            const markers = []
            let requestData = {
                "instanceId": "OA_UAT",
                "clientId": Session_Client_Id,
                "eventId": Session_Event_Id,
                "numHours": hours,
                "timeZone": Session_TimeZone,
                "numHours": hours
            }
            let headers = {
                "content-type": "application/json"
            }
            axios.post(LoginSummaryFetchAPI, requestData, { headers: headers }).then((response) => {
                response.data.rows.map((row4) => {
                        var first_name = row4.userName.split(' ')[0]
                        var last_name = row4.userName.substring(first_name.length).trim()
                          mObj.Fname = first_name;
                          mObj.Lname = last_name;
                          mObj.Uname = row4.userName;
                          mObj.UserEmail = row4.userEmail;
                          mObj.actionLabel = row4.loginType;
                          mObj.UserAgent = row4.os;
                          mObj.ActionTimeStr = row4.dtm;
                          mObj.city = row4.city;
                          mObj.userIp = row4.userIp;
                    markers.push(mObj);
                    mObj = {};
                });
                resolve({ status: 200, data: markers })
            }).catch((error) => {
                console.log('Error fetching user login data==:', error)
            })

        })
    },
    fetchAttendee(context, id) {
        //console.log(id)
        return new Promise((resolve, reject) => {
            if (id === null) {
                resolve({
                    status: 200,
                    data: {
                        Name: '',
                        FirstName: '',
                        LastName: '',
                        Email: '',
                        //Password: randomNumber,
                        Tags: '',
                        Phone: '',
                        Country: '',
                        Company: '',
                        Designation: '',
                        Profile: '',
                        ProfilePictureURL: '',
                        Website: '',
                        SocialLinks: []
                    }
                })
            } else {
                let docObj = new Object
                uerActionRef.doc(`${id}`).get().then(function (doc) {
                    docObj = doc.data()
                    //onsole.log(id)
                    //if(doc.data().SocialLinks) {

                    docObj.SocialLinks = {
                        /*Facebook: doc.data().SocialLinks[0].Facebook,
                        GooglePlus: doc.data().SocialLinks[1].GooglePlus,
                        LinkedIn: doc.data().SocialLinks[2].LinkedIn,
                        Twitter: doc.data().SocialLinks[3].Twitter  */
                    }

                    if (doc.data().SocialLinks) {
                        for (let i = 0; i < doc.data().SocialLinks.length; i++) {
                            let socialkeys = Object.keys(doc.data().SocialLinks[i])
                            let socialvaues = Object.values(doc.data().SocialLinks[i])
                            if (socialkeys[0] && socialvaues[0])
                                docObj.SocialLinks[socialkeys[0]] = socialvaues[0]
                        }
                    }

                    userRef.where("Email", "==", doc.data().Email.toLowerCase()).get().then(function (snapShot) {
                        let userdoc = snapShot.docs[0];
                        docObj.Password = userdoc.data().Password
                        resolve({ status: 200, data: docObj })
                    })



                }).catch(function (error) {
                    //console.log('Error getting mapped attendee:', error)
                    reject(error)
                })
            }

        })
    },
    fetchUserLoginDataForReport(context) {
        //debugger
        var date = new Date();
        var currentDate = new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), 0, 0, 0);
        return new Promise((resolve, reject) => {
            let markers = []
            let markers1 = []
            var query;
            if (currentDate != null) {
                query = userLoginRef.where("actionType", "==", "action").where("timestamp", ">", currentDate).orderBy("timestamp", "desc")
            }

            query.get().then(querySnapshot => {
                //querySnapshot.docs.forEach(doc => {
                //    markers.push(doc.data())
                //})

                querySnapshot.docs.forEach(doc => {
                    var data = doc.data();
                    var mObj = {};
                    var docs = markers1.filter(function (value) {
                        return value.UID == data.UID;
                    });
                    if (docs.length == 0) {
                        var mObj = {};
                        mObj.UID = data.UID;
                        mObj.Uname = data.Uname;
                        mObj.UserEmail = data.UserEmail;
                        mObj.actionLabel = data.actionLabel;
                        mObj.action = data.action;
                        mObj.actionType = data.actionType;
                        mObj.UserAgent = data.userAgent;
                        mObj.ActionTime = data.timestamp;
                        markers1.push(mObj)
                    }
                });
                markers1.sort(
                    function (a, b) {
                        if (a.ActionTime > b.ActionTime) {
                            return -1;
                        }
                        if (a.ActionTime < b.ActionTime) {
                            return 1;
                        }
                        return 0;
                    });
                resolve({ status: 200, data: markers1 })
                //resolve(markers1);
            }).catch(function (error) {
                //console.log('Error getting attendee:', error)
                reject(error)
            })
        })
    },
    fetchLiveVisitorwData(context, filterDayOrhours) {
        var hours = 0;
        if (filterDayOrhours == 6 || filterDayOrhours == 12 || filterDayOrhours == 24 || filterDayOrhours == 48) {
            hours = filterDayOrhours;
        } else if (filterDayOrhours == 3 || filterDayOrhours == 7) {
            hours = (filterDayOrhours * 24);
        } else {
            hours = (5000 * 24);
        }
        return new Promise((resolve, reject) => {
            var mObj = {};
            const markers = []
            let requestData = {
                "instanceId": "OA_UAT",
                "clientId": Session_Client_Id,
                "eventId": Session_Event_Id,
                "timeZone": Session_TimeZone,
                "numHours": hours,
            }
            let headers = {
                "content-type": "application/json"
            }
            axios.post(FetchLiveVisitorDataAPI, requestData, { headers: headers }).then((response) => {
                response.data.rows.map((row4) => {
                    var first_name = row4.userName.split(' ')[0]
                    var last_name = row4.userName.substring(first_name.length).trim()
                    mObj.UID = row4.userId;
                    mObj.Uname = row4.userName;
                    mObj.Fname = first_name;
                    mObj.Lname = last_name;
                    mObj.UserEmail = row4.userEmail;
                    mObj.page = row4.pageName;
                    mObj.ActionLabel = "Page View";
                    mObj.ActionTimeStr = row4.dtm;
                    mObj.DeviceInfo = row4.os;
                    mObj.city = row4.city;
                    mObj.userIp = row4.userIp;
                    
                    //mObj.page = row4.viewCount + row4.actionCount
                    markers.push(mObj);
                    mObj = {};
                });
                var totalCount =  response.data.grandTotal;
                resolve({ status: 200, data: markers , count :  totalCount})
            }).catch((error) => {
                console.log('Error fetching live visitor data==:', error)
            })

        })

    },
    fetchUserLastLoginData(context, filterdays) {
        //debugger
        var hours = 0;
        if (filterdays == 3 || filterdays == 7 || filterdays == 15 || filterdays == 30) {
            hours = (filterdays * 24);
        } else if (filterdays == 0) {
            hours = 24;
        } else if ([6,12,48].includes(filterdays)) {
            hours = filterdays;
        } else {
            hours = (5000 * 24);
        }
        return new Promise((resolve, reject) => {
            var mObj = {};
            const markers = []
            let requestData = {
                "instanceId": "OA_UAT",
                "clientId": Session_Client_Id,
                "eventId": Session_Event_Id,
                "numHours": hours,
                "timeZone": Session_TimeZone,
                "numHours": hours
            }
            let headers = {
                "content-type": "application/json"
            }
            axios.post(UniqueLoginSummaryFetchAPI, requestData, { headers: headers }).then((response) => {
                response.data.rows.map((row4) => {
                        var first_name = row4.userName.split(' ')[0]
                        var last_name = row4.userName.substring(first_name.length).trim()
                          mObj.Fname = first_name;
                          mObj.Lname = last_name;
                          mObj.Uname = row4.userName;
                          mObj.UserEmail = row4.userEmail;
                          mObj.actionLabel = row4.loginType;
                          mObj.UserAgent = row4.os;
                          mObj.ActionTimeStr = row4.dtm;
                          mObj.city = row4.city;
                    markers.push(mObj);
                    mObj = {};
                });
                resolve({ status: 200, data: markers })
            }).catch((error) => {
                console.log('Error fetching user login data==:', error)
            })

        })
    },
    fetchAdvanceReportsByUserOrPageName(context, field) {
        var hours = (5000 * 24);
       
        return new Promise((resolve, reject) => {
            var mObj = {};
            const markers = []
            let requestData = {
                "instanceId": "OA_UAT",
                "clientId": Session_Client_Id,
                "eventId": Session_Event_Id,
                "numHours": hours,
                "pageName": field.pageName != null ? field.pageName : "",
                "action": "click",
                "userId": field.userId != null ? field.userId : "",
                "timeZone": Session_TimeZone
            }
            let headers = {
                "content-type": "application/json"
            }
            axios.post(FetchAllUserActionByPageNameOrUserId, requestData, { headers: headers }).then((response) => {
                response.data.map((row4) => {
                    mObj.page = row4.pageName;
                    mObj.dateTime = row4.dtm;
                    mObj.userId = row4.userId;
                    mObj.userName = row4.userName;
                    mObj.userEmail = row4.userEmail;
                    mObj.actionLabel = row4.actionLabel;
                    mObj.city = row4.city;
                    mObj.state = row4.state;
                    mObj.country = row4.country;
                    mObj.device = row4.device;
                    mObj.os = row4.os;
                    mObj.browser = row4.browser;
                    markers.push(mObj);
                    mObj = {};
                });
                resolve({ status: 200, data: markers })
            }).catch((error) => {
                console.log('Error fetching bulk engagement data==:', error)
            })

        })

    },
}